<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <form @submit.prevent="saveBilling">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Billing statuses') }}</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Billing statuses') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('Only color display can be edited.') }}
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="name">{{ $t('Name') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input
                                            id="name"
                                            v-model="billing.name"
                                            :placeholder="$t('Name')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 bg-gray-100"
                                            readonly
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="value">{{ $t('Value') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input
                                            id="value"
                                            v-model="billing.value"
                                            :placeholder="$t('Value')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 bg-gray-100"
                                            readonly
                                            type="number"
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <input-color
                                        id="color"
                                        v-model="billing.color"
                                        :label="$t('Color')"
                                        :placeholder="$t('Choose color')"
                                        required
                                    ></input-color>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="stage-footer-surface text-right px-4 py-3 sm:px-6">
                        <span class="inline-flex">
                            <router-link
                                class="btn btn-secondary shadow-sm rounded mr-4"
                                to="/workspace/admin/settings/billings"
                            >
                                {{ $t('Close') }}
                            </router-link>
                            <button class="btn btn-gray shadow-sm rounded" type="submit">
                                {{ $t('Save') }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
import {UI_COLORS} from '@/utils/ui-colors';

export default {
    name: "edit",

    metaInfo() {
        return {
            title: this.$i18n.t('Billing statuses')
        }
    },
    data() {
        return {
            loading: true,
            billing: {
                name: null,
                slug: null,
                value: null,
                color: UI_COLORS.text.subtle,
            },
        }
    },
    mounted() {
        this.getBilling();
    },
    methods: {
        saveBilling() {
            const self = this;
            self.loading = true;
            axios.put('api/workspace/admin/billings/' + self.$route.params.id, {
                color: self.billing.color,
            }).then(function (response) {
                self.billing = response.data || self.billing;
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getBilling() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/admin/billings/' + self.$route.params.id).then(function (response) {
                self.billing = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}
</script>
